<template>
  <span class="c-list-badge">{{ ownerName }}</span>
</template>

<script>
export default {
  name: 'CIS-Resource-PagedListing-Badges',
  props: {
    ownerName: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.c-list-badge {
  display: inline-block;
  padding: 0.4rem 0.8rem 0.4rem 0.8rem;
  margin: 0 1rem 1rem 0;
  border-radius: 10rem;
  border: 1px solid rgba(0, 134, 191, 0.5);
  background: rgba(0, 134, 191, 0.05);
  @include font-styles('Arial Narrow', 1.2rem, 600, normal, normal, 0, rgba(0, 59, 92, 0.7));
}
</style>
